import React from 'react';

import CountdownElement from '../CountdownElement';

import MainMenu from '../../styled-components/MainMenu';
import Apply from '../../styled-components/Apply';
import Logo from '../../styled-components/Logo';
import GoogleButton from '../../styled-components/GoogleButton';
import GoogleButtonWrapper from '../../styled-components/GoogleButtonWrapper';

import logo from '../../img/header-logo.svg';
import smallLogo from '../../img/header-logo2.svg';

class Navbar extends React.Component {
  constructor() {
    super()
    this.state = { showMenu: false, smallLogo: false }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  };

  handleScroll = event => {
    const currentTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)

    currentTop > 550 ? this.setState({showMenu: true}) : this.setState({showMenu: false});
  };

  handleResize = event => {
    const currentWidth = window.innerWidth;

    currentWidth <= 900 ? this.setState({smallLogo: true}) : this.setState({smallLogo: false});
  };

  render() {
    return (
      <MainMenu show={this.state.showMenu}>
        <Apply light navBar><span>{this.props.apply.label}</span> <a href={this.props.apply.url} target="_blank">{this.props.apply.labelLink}</a></Apply>
        <h1 style={{verticalAlign: 'middle'}}><Logo src={this.state.smallLogo ? smallLogo : logo} /></h1>
        <GoogleButtonWrapper>
          <CountdownElement
            googleLogin={this.props.googleLogin}
            smallLogo={this.state.smallLogo}
            darkOnMobile={true}
            noMargin={true}
            isNav={true}
          />
        </GoogleButtonWrapper>
      </MainMenu>
    )
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js